import React , { useEffect, useState } from 'react'

import TestDashMenu from './TestDashMenu'
import TestDashData from './TestDashData'

import { ApiCallGet } from '../../../ApiCall/ApiCall';

function TestDashboard() {

    const [ clientes , setClientes ] = useState([])
    const [ lawyers , setLawyers ] = useState([])
    const [counters,setCounter] = useState(null)

    useEffect(()=>{

        onReload() ; // De entrada recargamos a los clientes

    } , [])


    useEffect(()=>{

        console.log( "Se actualizo el estado de clientes")

        var obj = {

            clientes : clientes.length ,
            lawyers : lawyers.length

        }

        setCounter( obj ) // Ponemos el contador de los elementos

    } , [clientes,lawyers])

    

    function onReload(){
        console.log("Recargando")

        ApiCallGet("/dashclient")
        .then((response) => {

            console.log( "dashclient = " , response )

            setClientes( response ) 


            ApiCallGet("/dashlawyer")
            .then((response) => {

                console.log("dashlawyer = ", response)

                for ( var i = 0 ; i < response.length ; i++  )
                {
                    response[i].name = response[i].lawyer_name + " " + response[i].lawyer_appaterno + " " +response[i].lawyer_apmaterno ;
                }

                setLawyers( response )

            })
            .catch((err)=> {

                console.log( "Nos llego un error =====>>>")

                console.log( err ) // Se detecto un error en la consulta

            })

        })
        .catch((err)=> {

            console.log( "Nos llego un error =====>>>")

            console.log( err ) // Se detecto un error en la consulta

        })
    }

  return (
    <div >
        
        <div className=' mt-4'>

            <TestDashMenu reload={onReload} counters={counters}/>
            
        </div>
        
        <TestDashData data={clientes} lawyers={lawyers}/>
        

    </div>
  )
}

export default TestDashboard